module.exports = __webpack_public_path__ + "img/president_message.f0ab9f0.webp";